import type { DialogProps, DialogTriggerProps } from '@radix-ui/react-dialog';
import { Root, Trigger, Portal, Overlay, Content, Title, Description, Close } from '@radix-ui/react-dialog';
import { Button, ClickableIcon } from '@zenid/web';
import { dialog } from '../../../../../../../styled-system/recipes';

export function MfaResetAlertDialog({
  onClickOk,
  onClickNG,
  children,
  ...props
}: Omit<DialogProps, 'children'> &
  Pick<DialogTriggerProps, 'children'> & { onClickOk: () => void; onClickNG: () => void }) {
  const {
    overlay: overlayStyle,
    content: contentStyle,
    titleAndDescriptionWrapper: titleAndDescriptionWrapperStyle,
    title: titleStyle,
    description: descriptionStyle,
    closeButton: closeButtonStyle,
    actionButtons: actionButtonsStyle,
  } = dialog();
  return (
    <Root {...props}>
      <Trigger asChild>{children}</Trigger>
      <Portal>
        <Overlay className={overlayStyle} />
        <Content className={contentStyle}>
          <div className={titleAndDescriptionWrapperStyle}>
            <Title className={titleStyle}>2段階認証をリセットしますか？</Title>
            <Description className={descriptionStyle}>
              現在の2段階認証がリセットされます。
              <br />
              引き続き「ZEN ID」をご利用いただくには、次の画面で新たに2段階認証を設定してください。
            </Description>
          </div>
          <div className={actionButtonsStyle}>
            <Button width={200} color="primary" size="m" onClick={onClickOk}>
              リセットする
            </Button>
            <Button width={200} color="tertiary" size="m" onClick={onClickNG}>
              リセットしない
            </Button>
          </div>
          <Close asChild>
            <ClickableIcon
              className={closeButtonStyle}
              name="close"
              color="colors.text.main"
              size="l"
              aria-label="閉じるボタン"
            />
          </Close>
        </Content>
      </Portal>
    </Root>
  );
}
